import { apiGetAuth, apiPutAuth } from '@/utils/api'
import { API_NOTIFICATION } from '@/utils/api-url'

const state = {
  notification_list: {
    isLoading: false,
    data: {} 
  }
}

const mutations = {
  "SET_NOTIFICATION_LIST": (state, payload) => {
    state.notification_list = payload
  }
}

const actions = {
  async getNotificationList(context, payload) {
    context.commit('SET_NOTIFICATION_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_NOTIFICATION.LIST, payload)
      context.commit('SET_NOTIFICATION_LIST', {
        isLoading: false,
        data: response?.data
      })
      return response?.data
    } catch {
      context.commit('SET_NOTIFICATION_LIST', {
        isLoading: false,
        data: {}
      })
    }
  },
  async updateNotificationList(context, payload) {
    context.commit('SET_NOTIFICATION_LIST', { isLoading: true })
    try {
      const response = await apiPutAuth(API_NOTIFICATION.LIST, payload)
      return response?.data
    } catch (err) {
      context.commit('SET_NOTIFICATION_LIST', { isLoading: false })
      throw err
    }
  }
}

const getters = {
  get_notification_list: state => {
    return state.notification_list
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
